<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1856054" style="color: #82a339"><b>CALDO VERDE</b></p>
<p class="ext" id="d7e1856754"><b><i>In Portugal, this delicious soup gets its rich green color from finely shredded Galician cabbage, which is sold in the outdoor markets. Kale, readily available in supermarkets, makes a fine substitute. If you like, sprinkle the soup with ½ cup finely chopped fully cooked spicy smoked sausage, such as linguiça or chorizo.</i></b></p>
<p class="h4" id="d7e1860154" style="color: #496210"><b>Prep: 15 minutes Cook: 40 to 45 minutes</b></p>
<p class="ul" id="d7e1860654">2 tablespoons olive oil</p>
<p class="ul" id="d7e1860954">1 large onion (12 ounces), chopped</p>
<p class="ul" id="d7e1861254">3 garlic cloves, finely chopped</p>
<p class="ul" id="d7e1861554">2½ pounds all-purpose potatoes (8 medium), peeled and cut into 2-inch pieces</p>
<p class="ul" id="d7e1863054">2 cans (14½ ounces each) chicken broth or 3½ cups Chicken Broth</p>
<p class="ul" id="d7e1865354">3 cups water</p>
<p class="ul" id="d7e1865654">1 teaspoon salt</p>
<p class="ul" id="d7e1865954">¼ teaspoon coarsely ground black pepper</p>
<p class="ul" id="d7e1866954">1 pound kale, tough stems and veins trimmed and leaves very thinly sliced</p>
<p class="pub" id="d7e1867754" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 5-quart Dutch oven, heat oil over medium heat. Add onion and garlic; cook until onion is golden, about 10 minutes. Add potatoes, broth, water, salt, and pepper; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, about 20 minutes.</p>
<p class="pub" id="d7e1870154"><span style="color: #c15b49"><b>2.</b></span> Mash potatoes in broth, keeping potatoes lumpy.</p>
<p class="pub" id="d7e1870854"><span style="color: #c15b49"><b>3.</b></span> Stir in kale; simmer, uncovered, until kale is tender, 5 to 8 minutes. Makes about 10 cups or 5 main-dish servings.</p>
<p class="ntx" id="d7e1872954">Each serving: About 251 calories, 7g protein, 41g carbohydrate, 7g total fat (1g saturated), 0mg cholesterol, 1,187mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c50_r1.vue?759587bd